import React from 'react';
import PropTypes from 'prop-types';
import Container from '@components/layout/container/container';
import Headline from '@components/atoms/headline/headline';
import StyledNewsletterTeaser from './newsletterTeaser.style';
import NewsletterFormCompact from '../newsletter-form/newsletterFormCompact';

const NewsletterTeaser = ({ data }) => {
  if (!data) return null;
  return (
    <StyledNewsletterTeaser aria-label={data.headline || 'Newsletter'}>
      <Container large>
        <div className="newsletter__container">
          <div className="newsletter__content">
            {data.topline && (
              <Headline subline tag="span">
                {data.topline}
              </Headline>
            )}
            {data.headline && <Headline primary>{data.headline}</Headline>}
          </div>
          <div className="newsletter__form">
            <NewsletterFormCompact />
          </div>
        </div>
      </Container>
    </StyledNewsletterTeaser>
  );
};

NewsletterTeaser.propTypes = {
  data: PropTypes.shape({
    topline: PropTypes.string,
    headline: PropTypes.string
  })
};

export default NewsletterTeaser;
